/* eslint-disable no-unused-vars */
/**
 * need
 * GET_ONE
 * DELETE
 * UPDATE
 */
import { jsonParams } from "./Utils";
import { CONFIG_API } from "@/plugins/axios";
import { parseBRPattern } from "@/models/Utils.js";
import Vue from "vue";
// import clientMQTT from "@/services/mqtt/configuration";
import moment from "moment";

const options = {
  qos: 1,
};
const textDecoder = new TextDecoder("utf-8");
const badQuality = 0;
const goodQuality = 1;

export default class RealtimeMeasure {
  constructor(item) {
    this.id = item.id;
    this.name = item.name;
    this.nameRef = "";
    this.description = item.description;
    this.decimalPlace = item.decimal_place;
    this.multiplier = item.multiplier;
    this.eu = item.eu;
    this.category = item.category;
    this.plant = item.plant;
    this.equipment = item.equipment;
    this.service = item.service;
    this.sourceInterface = item.interface;
    this.pathname = item.pathname;
    this.decimalPlace = item.decimalPlace;
    this.multiplier = item.multiplier ? parseFloat(item.multiplier) : 1;
    this.value = undefined;
    this.quality = undefined;
    this.timestamp = undefined;
    this.topic = `${item.topic}/#`;
    this.topicValue = `${item.topic}/Value`;
    this.topicTimeStamp = `${item.topic}/Timestamp`;
    this.topicQuality = `${item.topic}/Quality`;
    this.clientMQTT = undefined;
  }

  setMQTT(clientMQTT) {
    if (clientMQTT) {
      this.clientMQTT = clientMQTT;
      this.listen();
    }
  }

  setAttributes(realtimeRef) {
    const { name, multiplier, description, eu, decimalPlace } = realtimeRef;
    if (multiplier) this.multiplier *= parseFloat(multiplier);
    if (description) this.description = description;
    if (eu) this.eu = eu;
    if (typeof decimalPlace === "number" && decimalPlace >= 0) this.decimalPlace = decimalPlace;
    if (name) {
      this.nameRef = this.name;
      this.name = name;
    }
    return this;
  }

  setValue(value) {
    Vue.set(this, "value", value);
  }

  setQuality(value) {
    Vue.set(this, "quality", value);
  }

  setTimeStamp(value) {
    Vue.set(this, "timestamp", value);
  }

  setTopic(topic = "") {
    if (topic) {
      this.topic = `${topic}/#`;
      this.topicValue = `${topic}/Value`;
      this.topicTimeStamp = `${topic}/Timestamp`;
      this.topicQuality = `${topic}/Quality`;
    }
  }
  isDatetimeFormat() {
    if (moment(this.timestamp).isValid()) return true;
    return false;
  }
  getTimestamp(format) {
    if (this.isDatetimeFormat()) {
      if (format) return moment(this.timestamp).format(format);
      return this.timestamp;
    } else {
      return this.convertTimestampNumber(format);
    }
  }
  convertTimestampNumber(format) {
    const correction = 86400000;
    const sql_base = new Date("1899-12-29 23:53:32"); //Zero time is December 30, 1899 00:00:00 UTC. + correcao de fuso datetime(1914, 1, 1, 0, 6, 28, 0)
    // const js_base = new Date("1970-01-01 00:00:00") //Zero time is January 01, 1970 00:00:00 UTC.
    let milliseconds = undefined;
    if (this.checkTimestamp()) {
      milliseconds = this.toFloat(this.timestamp) * correction + sql_base.getTime();
    }
    if (format && milliseconds) return moment(milliseconds).format(format);
    return milliseconds;
  }

  getEu() {
    return this.eu ? this.eu : "";
  }

  getValue(decimal_places, BRPattern = true) {
    if (!this.checkVal()) return "-";
    if (!this.checkQuality()) return "???";
    if (!decimal_places && decimal_places != 0) decimal_places = this.decimalPlace;
    if (!decimal_places && decimal_places != 0) decimal_places = 2;
    let str_val = this.value.toFixed(decimal_places);
    if (str_val.includes("e")) {
      let split_val = str_val.split("e");
      let n_val = parseFloat(split_val[0]).toFixed(decimal_places);
      if (BRPattern) n_val = n_val.replace(".", ",");
      str_val = `${n_val}e${split_val[1]}`;
    } else {
      str_val = parseFloat(String(this.value).replace(",", ".")).toFixed(decimal_places);
      if (BRPattern) str_val = parseBRPattern(str_val);
    }
    return str_val;
  }
  address() {
    if (this.sourceInterface && this.pathname) {
      return `${this.sourceInterface} : ${this.pathname}`;
    } else if (this.sourceInterface) {
      return this.sourceInterface;
    } else if (this.pathname) {
      return this.pathname;
    }
    return "";
  }
  round(decimal_places) {
    if (!decimal_places && decimal_places != 0) decimal_places = this.decimalPlace;
    if (!decimal_places && decimal_places != 0) decimal_places = 2;
    return parseFloat(parseFloat(String(this.value).replace(",", ".")).toFixed(decimal_places));
  }
  float() {
    return parseFloat(String(this.value).replace(",", "."));
  }
  int() {
    return parseInt(String(this.value).replace(",", "."));
  }
  str() {
    return String(this.value);
  }
  copy() {
    const topic = this.topic.replace("/#", "");
    const realtime = new RealtimeMeasure(Object.assign({ ...this }, { topic }));
    realtime.setMQTT(this.clientMQTT);
    return realtime;
  }
  check() {
    return this.checkVal() && this.checkQuality();
  }
  checkQuality() {
    if (this.quality) {
      switch (parseInt(this.quality)) {
        case badQuality:
          return false;
        case goodQuality:
          return true;
      }
    }
    return true;
  }
  checkVal() {
    if (this.float() !== 0 && this.value !== false) {
      if (!this.value) return false;
      if (this.value === "undefined") return false;
      if (this.value === "null") return false;
    }
    return true;
  }
  checkTimestamp() {
    if (this.toFloat(this.timestamp) !== 0 && this.timestamp !== false) {
      if (!this.timestamp) return false;
      if (this.timestamp === "undefined") return false;
      if (this.timestamp === "null") return false;
    }
    return true;
  }
  checkTopic() {
    if (!this.topic) return false;
    if (this.topic === "undefined") return false;
    if (this.topic === "null") return false;
    if (this.topic === "false") return false;
    return true;
  }
  deleteTopic() {
    for (const key in this.clientMQTT.messageIdToTopic) {
      for (let i = 0; i < this.clientMQTT.messageIdToTopic[key].length; i++) {
        let elem = this.clientMQTT.messageIdToTopic[key][i];
        if (elem == this.topic) {
          this.clientMQTT.messageIdToTopic[key].splice(i, 1);
        }
      }
      if (this.clientMQTT.messageIdToTopic[key].length <= 0)
        delete this.clientMQTT.messageIdToTopic[key];
    }
  }
  subscribe() {
    if (this.checkTopic()) {
      this.clientMQTT.subscribe(this.topic, options);
    }
  }
  unsubscribe() {
    if (this.checkTopic()) {
      this.clientMQTT.unsubscribe(this.topic);
      this.deleteTopic();
    }
  }
  listen() {
    if (this.checkTopic()) {
      this.clientMQTT.on("message", (topic, response) => {
        const value = textDecoder.decode(response);
        switch (topic) {
          case this.topicValue:
            let res = value;
            if (this.multiplier) res *= this.multiplier;
            this.setValue(res);
            break;
          case this.topicQuality:
            this.setQuality(value);
            break;
          case this.topicTimeStamp:
            this.setTimeStamp(value);
            break;
        }
      });
    }
  }
  toFloat(val) {
    return parseFloat(String(val).replace(",", "."));
  }
}

export async function getRealtimeMeasures(params) {
  try {
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Authorization: "JWT " + localStorage.getItem("config_token"),
    };
    const config = { headers, params };
    let res = await CONFIG_API.get("realtime-measures/", config);
    if (res && res.status == 200) {
      if ("page" in res.data) {
        res.data.results = res.data.results.map((e) => new RealtimeMeasure(e));
        return res.data;
      }
      let data = res.data.map((e) => new RealtimeMeasure(e));
      return data;
    }
  } catch (e) {
    console.error(e);
    return [];
  }
}

export async function insertRealtimeMeasure(data) {
  try {
    const headers = {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: "JWT " + localStorage.getItem("config_token"),
    };
    const config = { headers };

    let res = await CONFIG_API.post("realtime-measures/", data, config);
    return res;
  } catch (e) {
    console.error(e);
    return e;
  }
}
